<div class="padding-component">
    <app-header [title]="'Locaciones de: ' + client?.name" [backButton]="true"></app-header>

    <app-locations [locationsList]="locationsList" [client]="client"></app-locations>
</div>